import React from "react";
import { useBadgeMap } from "@/lib/auth-context";
import { toast } from "sonner";

export function badgeToast(slug, badgeMap) {
  const b = badgeMap[slug];
  if (!b) return;
  toast.success(
    <div>
      <div className="font-display font-black text-lg">{b.emoji} Badge débloqué : {b.label}</div>
      <div className="text-xs">{b.description}</div>
    </div>
  );
}

export default function useBadgeToast() {
  const map = useBadgeMap();
  return React.useCallback((slugs) => {
    (slugs || []).forEach((s) => badgeToast(s, map));
  }, [map]);
}
